<template>
  <div class="card mb-0">
    <div class="card-body"  v-if="invoiceDetails">

      <div v-if="invoiceDetails.invoice" class="invoice-number mb-2 ml-0">
        Arve
        <router-link :to="`/invoices/${invoiceDetails.invoice.id}`">
          {{invoiceDetails.invoice.number}}
          <i class="mdi mdi-chevron-right"></i>
        </router-link>
        {{invoiceDetails.invoice.statusLabel}}
      </div>

      <div  v-if="invoiceDetails.taxes.length">

        <table class="table table-sm table-striped mb-3 table-centered">
          <thead>
          <th width="20%">Maks</th>
          <th>Summa</th>
          <th>Arveldatav</th>
          <th>Seotud arve</th>
          <th></th>
          <th></th>
          </thead>
          <tbody>
          <template v-for="tax in invoiceDetails.taxes">
            <tr class="tax">
              <td class="tax-name">{{tax.name}}</td>
              <td class="tax-amount">{{tax.amount | amountWithCurrency}}</td>
              <td><i class="mdi" :class="{'mdi-check': tax.invoiceable}"></i></td>
              <td>
                <router-link :to="`/invoices/${tax.invoice.id}`" v-if="tax.invoice">
                  {{tax.invoice.number}}
                  <i class="mdi mdi-chevron-right"></i>
                </router-link>
              </td>
              <td><span v-if="tax.invoice">{{tax.invoice.statusLabel}}</span></td>
              <td>
                <button v-if="tax.canBeCredited" @click="creditInvoice(tax.invoice.id)" class="btn btn-outline-primary btn-sm">
                  <i class="mdi mdi-undo-variant mr-1"></i>Krediteeri
                </button>
              </td>
            </tr>
          </template>
          </tbody>
        </table>

        <div class="row">
          <div class="col-7">
          </div>
          <div class="col-4">
            Kokkuvõte:
            <div class="row" :class="{'text-danger': invoiceDetails.totals.unbilledAmount > 0}">
              <div class="col-6"><strong>Arvele lisamata</strong></div>
              <div class="col-6 text-right"><strong>{{invoiceDetails.totals.unbilledAmount | amountWithCurrency}}</strong></div>
            </div>
            <div class="row">
              <div class="col-6">Arveldatavad</div>
              <div class="col-6 text-right">{{invoiceDetails.totals.invoiceableAmount | amountWithCurrency}}</div>
            </div>
            <div class="row">
              <div class="col-6">Mittearveldatavad</div>
              <div class="col-6 text-right">{{invoiceDetails.totals.uninvoiceableAmount | amountWithCurrency}}</div>
            </div>
          </div>
          <div class="col"></div>
        </div>

      </div>

      <div v-else>
        <i class="mdi mdi-alert-circle-outline"></i> Maksud puuduvad
      </div>

      <div v-if="!invoiceDetails.invoice">
        <i class="mdi mdi-alert-circle-outline"></i> Arved puuduvad
      </div>

    </div>
  </div>
</template>

<script>
  import gateway from '@/services/gateway'

  export default {
    props: ['declarationId', 'declaration'],
    data() {
      return {
        invoiceDetails: null
      }
    },
    methods: {
      sortAsInvoiceableFirst() {
        this.invoiceDetails.taxes.sort((a, b) => {
          if (a.invoiceable && !b.invoiceable) return -1;
          if (a.invoiceable === b.invoiceable) return 0;
          return 1;
        })
      },
      loadDeclaration() {
        gateway.get(`/declarations/${this.declarationId}`).then(r => {
          this.invoiceDetails = r.data
          this.sortAsInvoiceableFirst()
        })
      },
      creditInvoice(invoiceId) {
        const declarationId = this.invoiceDetails.id

        gateway.post(`/invoices/${invoiceId}/credit-for-declaration`, {declarationId: declarationId}).then(r => {
          this.$router.push(`/invoices/${r.data}`)
          this.$notifications.info('Kreeditarve loodud, vaadake üle')
        })
      }
    },
    created() {
      this.invoiceDetails = this.declaration

      if (!this.invoiceDetails)
        this.loadDeclaration()

      this.$parent.$on('reload-declarations', this.loadDeclaration);
    }
  }
</script>
